// 正式
module.exports = {
  title: '领克|领克汽车|Lynk&Co',
  baseUrl: 'https://usedcar.lynkco.com/service',
  // 正式项目地址
  baseApi: 'https://usedcar.lynkco.com/service',
  // 正式api请求地址
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: '',
  gaode_key: '42c429b67bff8d888951c99c93fcfe37',
  mapDomain: 'https://usedcar.lynkco.com/_AMapService',
  replaceClueOrigin: '97809fefce734c28'
};

// module.exports = {
//   title: 'Lynkco',
//   baseUrl: 'http://39.103.134.106:9090', // 项目地址
//   baseApi: 'http://39.103.134.106:9090', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
//   APPID: 'xxx',
//   APPSECRET: 'xxx',
//   $cdn: ''
// }